module.exports = "/images/Homepage-Exterior.jpg";